import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Menu from '@components/menu';
import Typography from '@components/basics/typography';
import Flex from '@components/layout/flex';
import FilterIcon from '@components/basics/icons/filter';
import SimpleDropdownItem from '@components/form/dropdown/dropdown-item/simple-dropdown-item';

interface EarningsFilterProps {
  className?: string;
  currentValue?: string;
  setDateRange: React.Dispatch<React.SetStateAction<string>>;
}

export const FILTER_OPTIONS = [
  {
    value: 'latestMonth',
    label: 'Latest Month',
    hideOption: true,
  },
  {
    value: 'lastWeek',
    label: 'Last week',
  },
  {
    value: 'lastMonth',
    label: 'Last month',
  },
  {
    value: 'last3Months',
    label: 'Last 3 months',
  },
  {
    value: 'lastYear',
    label: 'Last year',
  },
  {
    value: 'allTime',
    label: 'All time',
  },
];

export const EarningsFilter: React.FC<EarningsFilterProps> = (props) => {
  const [option, setOption] = React.useState<string>('latestMonth');
  React.useEffect(() => {
    if (props.currentValue) {
      setOption(props.currentValue);
    }
  }, [props]);

  return (
    <StyledFlex alignItems="center">
      <Typography weight="700">
        <Translate id="EARNINGS.FILTERS.DATE_RANGE" />
      </Typography>
      <Menu
        className={props.className}
        button={<FilterIcon />}
        alignCenter
        menuId="MENU"
      >
        <div>
          {FILTER_OPTIONS.filter((o) => !o.hideOption).map((dateOption, i) => (
            <SimpleDropdownItem
              key={`dropdown-${i}`}
              active={dateOption.value === option}
              onClick={() => {
                props.setDateRange(dateOption.value);
                setOption(dateOption.value);
              }}
            >
              {dateOption.label}
            </SimpleDropdownItem>
          ))}
        </div>
      </Menu>
    </StyledFlex>
  );
};

export default EarningsFilter;

const StyledFlex = styled(Flex)`
  background: #f1f2f5;
  justify-content: space-evenly;
  width: 146px;
  height: 50px;
  border-radius: 20px;
`;
